/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'fDC9vQTaET8tVf7YdmovxZ.png': { uri: '/images/fDC9vQTaET8tVf7YdmovxZ.png' },
'9M7UxUbCP1bU6Df3qs5TeW.jpg': { uri: '/images/9M7UxUbCP1bU6Df3qs5TeW.jpg' },
'vDBTmHiEEKQm5hdm6xBhhT.png': { uri: '/images/vDBTmHiEEKQm5hdm6xBhhT.png' },
'vB5Fdde7cE86nTQ6GRAZok.png': { uri: '/images/vB5Fdde7cE86nTQ6GRAZok.png' },
'fjV7GNWt4LPZeRSnLBBUFR.png': { uri: '/images/fjV7GNWt4LPZeRSnLBBUFR.png' },
'i3Qa3Gkt35XEbhCR1fWn8M.png': { uri: '/images/i3Qa3Gkt35XEbhCR1fWn8M.png' },
'fTWhgj7Gci4QpfZh2z7S5L.png': { uri: '/images/fTWhgj7Gci4QpfZh2z7S5L.png' },
'7je33XaLCS867ztFLiHTQk.png': { uri: '/images/7je33XaLCS867ztFLiHTQk.png' },
'gNA9fEUHmCpfzHTyQqUSvD.png': { uri: '/images/gNA9fEUHmCpfzHTyQqUSvD.png' },
'puoEbF6Jvmgu78F1QZwZDi.png': { uri: '/images/puoEbF6Jvmgu78F1QZwZDi.png' },
'jb3yAogxWQ9yPKzTTwC7kf.png': { uri: '/images/jb3yAogxWQ9yPKzTTwC7kf.png' },
'3DsoJTLTrt7UzW4DVvit5M.png': { uri: '/images/3DsoJTLTrt7UzW4DVvit5M.png' },
'5kDQcW29c7czLn4KcB1Ydp.png': { uri: '/images/5kDQcW29c7czLn4KcB1Ydp.png' },
'nKnCGi9bqeD7CaBbP8yXUJ.png': { uri: '/images/nKnCGi9bqeD7CaBbP8yXUJ.png' }
}

export default imageStaticSourcesByFileName
